import * as Types from '../../../types/graphql.generated';

import { gql } from '@apollo/client';
import { MainEventFragmentDoc } from '../../fragments/generated/main-event.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteScheduledNotificationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type DeleteScheduledNotificationMutation = { __typename?: 'Mutation', deleteScheduledNotification: { __typename?: 'Notification', id: string, createdAt: string, updatedAt: string, en?: { __typename?: 'NotificationMessage', title?: string | null, body?: string | null, mainEvent?: { __typename?: 'MainEvent', id: string, name: string, status: Types.StatusTypes, locale: string, description?: string | null, content?: string | null, showScheduleLink?: boolean | null, position?: number | null, disableInfoAndProgram?: boolean | null, mainPageId?: string | null, createdAt: string, updatedAt: string, logo?: { __typename?: 'Media', id: string, name: string, locale: string, altText?: string | null, caption?: string | null, originalUrl: string, type: Types.MediaType, mimetype: string, createdAt: string, updatedAt: string, formats: { __typename?: 'Formats', xs: { __typename?: 'MediaFormat', url: string, width: number }, s: { __typename?: 'MediaFormat', url: string, width: number }, m: { __typename?: 'MediaFormat', url: string, width: number }, l: { __typename?: 'MediaFormat', url: string, width: number }, xl: { __typename?: 'MediaFormat', url: string, width: number } } } | null } | null } | null, de?: { __typename?: 'NotificationMessage', title?: string | null, body?: string | null, mainEvent?: { __typename?: 'MainEvent', id: string, name: string, status: Types.StatusTypes, locale: string, description?: string | null, content?: string | null, showScheduleLink?: boolean | null, position?: number | null, disableInfoAndProgram?: boolean | null, mainPageId?: string | null, createdAt: string, updatedAt: string, logo?: { __typename?: 'Media', id: string, name: string, locale: string, altText?: string | null, caption?: string | null, originalUrl: string, type: Types.MediaType, mimetype: string, createdAt: string, updatedAt: string, formats: { __typename?: 'Formats', xs: { __typename?: 'MediaFormat', url: string, width: number }, s: { __typename?: 'MediaFormat', url: string, width: number }, m: { __typename?: 'MediaFormat', url: string, width: number }, l: { __typename?: 'MediaFormat', url: string, width: number }, xl: { __typename?: 'MediaFormat', url: string, width: number } } } | null } | null } | null } };


export const DeleteScheduledNotificationDocument = gql`
    mutation DeleteScheduledNotification($id: ID!) {
  deleteScheduledNotification(id: $id) {
    id
    en {
      title
      body
      mainEvent {
        ...mainEvent
      }
    }
    de {
      title
      body
      mainEvent {
        ...mainEvent
      }
    }
    createdAt
    updatedAt
  }
}
    ${MainEventFragmentDoc}`;
export type DeleteScheduledNotificationMutationFn = Apollo.MutationFunction<DeleteScheduledNotificationMutation, DeleteScheduledNotificationMutationVariables>;

/**
 * __useDeleteScheduledNotificationMutation__
 *
 * To run a mutation, you first call `useDeleteScheduledNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduledNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduledNotificationMutation, { data, loading, error }] = useDeleteScheduledNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScheduledNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduledNotificationMutation, DeleteScheduledNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScheduledNotificationMutation, DeleteScheduledNotificationMutationVariables>(DeleteScheduledNotificationDocument, options);
      }
export type DeleteScheduledNotificationMutationHookResult = ReturnType<typeof useDeleteScheduledNotificationMutation>;
export type DeleteScheduledNotificationMutationResult = Apollo.MutationResult<DeleteScheduledNotificationMutation>;
export type DeleteScheduledNotificationMutationOptions = Apollo.BaseMutationOptions<DeleteScheduledNotificationMutation, DeleteScheduledNotificationMutationVariables>;